import { render, staticRenderFns } from "./ShatenManagement.vue?vue&type=template&id=3a61e6d1&scoped=true&"
import script from "./ShatenManagement.vue?vue&type=script&lang=ts&"
export * from "./ShatenManagement.vue?vue&type=script&lang=ts&"
import style0 from "./ShatenManagement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShatenManagement.vue?vue&type=style&index=1&id=3a61e6d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61e6d1",
  null
  
)

component.options.__file = "ShatenManagement.vue"
export default component.exports